export const secretKey = "a3f8d7c2e9b4a1f5e6d3c8b2a9e7d4c1a8f5b6c3e2d9f4b7c1a8d5e6f3b2c7";
